module.exports = __webpack_public_path__ + "lounge-a84310a9708356d08e50063de1bb54c5.svg";